export const RESEARCH_PANEL_BODY_HEIGHT = 430;

export const PORTFOLIO_CARD_CLASSNAME =
  'relative flex min-w-0 w-full flex-col overflow-hidden rounded-xl border border-slate-200 bg-white shadow-[0_1px_2px_rgba(15,23,42,0.04)]';

export const WATCHLIST_QUOTES_TABLE_FRAME_CLASS =
  'max-h-[min(420px,60vh)] min-h-[min(420px,60vh)] overflow-auto';

export const WATCHLIST_QUOTES_SYMBOL_CELL_CLASS = 'flex min-w-0 flex-col items-start justify-center';

/** Matches skeleton thead (`text-[11px]` + vertical padding) and border. */
const RESEARCH_TABLE_HEADER_HEIGHT = 42;
const RESEARCH_TABLE_ROW_HEIGHT = 52;

export const getResearchTableSkeletonRowCount = (bodyHeight = RESEARCH_PANEL_BODY_HEIGHT) =>
  Math.max(1, Math.floor((bodyHeight - RESEARCH_TABLE_HEADER_HEIGHT) / RESEARCH_TABLE_ROW_HEIGHT));

export const ANALYST_RATINGS_SKELETON_COLUMNS = [
  'Symbol',
  'Date',
  'Firm',
  'Current Price Target',
  'Upside/Downside Change',
  'Rating',
  'Previous/Current Rating',
  'Price Target Change',
];
